{
    "BSB33": {
        "position": {
            "x": 6,
            "y": 7,
            "z": 1
        },
        "key": "BSB33",
        "tag": "goodspawn"
    },
    "tOXD0": {
        "position": {
            "x": 7,
            "y": 7,
            "z": 1
        },
        "key": "tOXD0",
        "tag": "goodspawn"
    },
    "dXbM8": {
        "position": {
            "x": 8,
            "y": 7,
            "z": 1
        },
        "key": "dXbM8",
        "tag": "goodspawn"
    },
    "ohd8q": {
        "position": {
            "x": 9,
            "y": 7,
            "z": 1
        },
        "key": "ohd8q",
        "tag": "goodspawn"
    },
    "BSB33x": {
        "position": {
            "x": 6,
            "y": 4,
            "z": 1
        },
        "key": "BSB33x",
        "tag": "badspawn"
    },
    "tOXD0x": {
        "position": {
            "x": 7,
            "y": 4,
            "z": 1
        },
        "key": "tOXD0x",
        "tag": "badspawn"
    },
    "dXbM8x": {
        "position": {
            "x": 8,
            "y": 4,
            "z": 1
        },
        "key": "dXbM8x",
        "tag": "badspawn"
    },
    "ohd8qx": {
        "position": {
            "x": 9,
            "y": 4,
            "z": 1
        },
        "key": "ohd8qx",
        "tag": "badspawn"
    }
}